/// <reference types="@angular/localize" />

import { CommonModule, DatePipe, registerLocaleData } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { CustomTranslationLoader } from "@core/helpers/translation/custom-translation-loader";
import { ConsoleMissingTranslationHandler } from "@core/helpers/translation/missing-translation-handler";
import { BEAuthInterceptor } from "@core/interceptors/interceptor";
import { RequestDebounceInterceptor } from "@core/interceptors/request-debounce.interceptor";
import { BELocalizationService } from "@core/services/global/localization/be-localization.service";
import {
  MissingTranslationHandler,
  provideTranslateService,
  TranslateLoader,
} from "@ngx-translate/core";
import { AppRoutingModule } from "./app/app-routing.module";

import localeEs from "@angular/common/locales/es";
import {
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { Router } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import * as Sentry from "@sentry/angular";
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";

registerLocaleData(localeEs);

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const enableSentry = environment?.sentry?.enable ?? false;
const sentryProviders = enableSentry
  ? [
      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler(),
      },
      {
        provide: Sentry.TraceService,
        deps: [Router],
      },
      provideAppInitializer(() => {
        inject(Sentry.TraceService);
      }),
    ]
  : [];

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      CommonModule,
      BrowserModule,
      AppRoutingModule,
      ReactiveFormsModule,
      NgbModule
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestDebounceInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: BEAuthInterceptor, multi: true },
    ...sentryProviders,
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslationLoader,
        deps: [BELocalizationService],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ConsoleMissingTranslationHandler,
      },
    }),
    {
      provide: MissingTranslationHandler,
      useClass: ConsoleMissingTranslationHandler,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    DatePipe,
  ],
}).catch(err => console.error(err));
